import { API } from "../../../cache";

async function apiFetch(url, opts = {}) {
  const res = await fetch(url, { credentials: "include", ...opts });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Request failed (${res.status})`);
  return data;
}

export const userExclusionsApi = {
  list(userId) {
    return apiFetch(`${API}/users/${userId}/exclusions`);
  },

  create(userId, payload) {
    return apiFetch(`${API}/users/${userId}/exclusions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  },

  update(userId, exclusionId, payload) {
    return apiFetch(`${API}/users/${userId}/exclusions/${exclusionId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  },

  delete(userId, exclusionId) {
    return apiFetch(`${API}/users/${userId}/exclusions/${exclusionId}`, {
      method: "DELETE",
    });
  },
};
